module.exports = __webpack_public_path__ + "static/flags/AC-c8a1cbba025060a11b23a84c9ef268a1.gif";